/**
 * Причины отказа и архивации заявки (решение Сергея 19.09.2026, п. 19 встречи
 * 17.09 с заказчиком).
 *
 * Раньше менеджер писал причину свободным текстом, и одно и то же в базе
 * выглядело по-разному: «не прошли», «не прошли по цене», «не прошли по
 * ценам», «дорого», «цены выше». Считать такую статистику невозможно.
 * Списки собраны по реальным текстам прод-базы (470 отказов и 281 архив,
 * выборка 19.09.2026). Комментарий остаётся и заполняется как раньше, для
 * причины «Другое» он обязателен.
 */

/** Код причины отказа (`requests.rejectionReasonCode`). */
export type RejectionReasonCode =
  | 'PRICE'
  | 'COMPETITOR'
  | 'LEAD_TIME'
  | 'CLIENT_CANCELLED'
  | 'NO_RESPONSE'
  | 'OTHER'

export const REJECTION_REASON_LABELS: Record<RejectionReasonCode, string> = {
  PRICE: 'Дорого — не прошли по цене',
  COMPETITOR: 'Выбрали другого поставщика',
  LEAD_TIME: 'Не устроили сроки',
  CLIENT_CANCELLED: 'Клиент отменил или отложил закупку',
  NO_RESPONSE: 'Нет ответа от клиента',
  OTHER: 'Другое',
}

export const REJECTION_REASON_CODES = Object.keys(REJECTION_REASON_LABELS) as RejectionReasonCode[]

/** Код причины архивации (`requests.archiveReasonCode`). */
export type ArchiveReasonCode =
  | 'ESTIMATE_ONLY'
  | 'NO_SUPPLIER_OFFERS'
  | 'PURCHASE_CANCELLED'
  | 'PRICE'
  | 'PARTIAL_BUYOUT'
  | 'OTHER'

export const ARCHIVE_REASON_LABELS: Record<ArchiveReasonCode, string> = {
  ESTIMATE_ONLY: 'Просчёт для клиента, сделки не было',
  NO_SUPPLIER_OFFERS: 'Нет предложений от поставщиков',
  PURCHASE_CANCELLED: 'Закупка отменена заказчиком',
  PRICE: 'Дорого — не прошли по цене',
  PARTIAL_BUYOUT: 'Частичный выкуп',
  OTHER: 'Другое',
}

export const ARCHIVE_REASON_CODES = Object.keys(ARCHIVE_REASON_LABELS) as ArchiveReasonCode[]

/** Для «Другого» комментарий обязателен — иначе причина ничего не объясняет. */
export function requiresComment(code: string): boolean {
  return code === 'OTHER'
}
